import React from 'react';
import icon from '../img/info.svg';
import arrow from '../img/circle-arrow-left.svg';

class WrittenNotice extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            choice: props.writtenNotice
        } 
    }

    render() {
        const props = this.props;
        const { choice } = this.state;

        return (
            <article className={`question q0 slide-${props.position}`}>
                <div className={`inner`}>
                    <div className="question__text">
                        <span>Haben Sie eine schriftliche Kündigung erhalten?</span>
                    </div>
                    <div className="question__field">
                        <select 
                            value={choice}
                            tabIndex="1"
                            onChange={(e) => this.setState({ choice: parseInt(e.target.value, 10) })}>
                                <option value="">Bitte wählen</option>
                                <option value="1">Ja</option>
                                <option value="2">Nein</option>
                        </select>
                    </div>
                </div>
                <div className="inner question__controls">
                    <div className="question__control">
                    </div>
                    <div className="question__control">
                        <a tabIndex="3"
                            className="question__info-icon" 
                            data-tip data-for="is-written-notice">
                                <img src={icon} />
                        </a>
                    </div>
                    <div className="question__control">
                        <a tabIndex={ choice ? "2" : "-1" }
                            onClick={() => props.updateWrittenNotice(choice)}
                            className={`question__next-link ${!choice ? 'hidden' : ''}`}>
                                <img src={arrow} />
                        </a>
                    </div>
                </div>
            </article>
        );
    }
};

export default WrittenNotice;


// WEBPACK FOOTER //
// ./src/components/input.written-notice.js